import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { SiteFooter } from "@/components/site/SiteFooter";
import { SiteHeader } from "@/components/site/SiteHeader";

function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace("#", ""));
      const scrollToHash = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return true;
        }
        return false;
      };
      if (!scrollToHash()) {
        const t = window.setTimeout(scrollToHash, 80);
        return () => window.clearTimeout(t);
      }
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}

export function SiteLayout() {
  const { pathname } = useLocation();

  return (
    <div className="min-h-screen bg-background text-foreground">
      <ScrollManager />
      <SiteHeader />
      <div key={pathname} className="page-enter">
        <Outlet />
      </div>
      <SiteFooter />
    </div>
  );
}
